import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { firebaseApp } from "./firebase";
import { axios } from "@/api";
import { API } from "@/api";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

let messagingInstance = null;

async function getMessagingInstance() {
  if (messagingInstance) return messagingInstance;
  const supported = await isSupported();
  if (!supported) return null;
  messagingInstance = getMessaging(firebaseApp);
  return messagingInstance;
}

export async function requestFCMToken() {
  try {
    const msg = await getMessagingInstance();
    if (!msg) return null;

    const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
    const token = await getToken(msg, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: reg,
    });

    if (token) {
      await axios.post(`${API}/notifications/token`, { fcm_token: token });
    }
    return token;
  } catch (e) {
    console.error("[FCM] Token request failed:", e);
    return null;
  }
}

export async function clearFCMToken() {
  try {
    await axios.delete(`${API}/notifications/token`);
  } catch {}
}

export function getNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission;
}
